export function sortByName(a: { name: string }, b: { name: string }) {
  if (a.name > b.name) {
    return 1;
  }
  if (b.name > a.name) {
    return -1;
  }
  return 0;
}
